/**
 * An inline spinner: Vibe's Loader, in the current text colour.
 *
 * Hidden from screen readers. Every spinner sits beside text (or inside a busy
 * region) that already says what is loading, and Loader announces itself as
 * an alert, which would repeat it on every render.
 */
import { Loader } from '@vibe/core';
import React from 'react';

export default function Spinner({ size = 16, className = '' }) {
  return (
    <span className={`spt-spinner ${className}`} aria-hidden="true">
      <Loader size={size} />
    </span>
  );
}
